import { PropsWithChildren, createContext, useContext, useState } from "react";

export type ConnectorConfigState = {
  host: string;
  clientId: string;
  username: string;
  password: string;
  timeout: boolean;
};

type IProps = PropsWithChildren<{ initialState: ConnectorConfigState }>;

const ConnectorConfigContext = createContext<{
  connectorConfig: ConnectorConfigState;
  setConnectorConfig: (data: ConnectorConfigState) => void;
}>(undefined!);

export const ConnectorConfigProvider = ({ initialState, children }: IProps) => {
  localStorage.removeItem("token");

  const [connectorConfig, setConnectorConfig] =
    useState<ConnectorConfigState>(initialState);
  window.addEventListener("message", (e) => {
    setTimeout(function () {
      var data = e.data; // hare are data sent by other window postMessage method
      if (data.type === "authData") {
        setConnectorConfig({
          clientId: data.data.clientId,
          username: data.data.username,
          password: data.data.password,
          host: data.data.host,
          timeout: false,
        });
      } else {
        setConnectorConfig({
          clientId: "",
          username: "",
          password: "",
          host: "",
          timeout: true,
        });
      }
    }, 3000);
  });

  return (
    <ConnectorConfigContext.Provider
      value={{ connectorConfig, setConnectorConfig }}
    >
      {children}
    </ConnectorConfigContext.Provider>
  );
};

export const useConnectorConfig = () => useContext(ConnectorConfigContext);
